import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { Col, Container, Row } from "react-bootstrap";
import {
  CheckBoxInput,
  FormContainer,
  FormGroupLabel,
  FormItem,
  Label,
} from "../../../shared/components/form/FormElements";
import { Card, CardBody } from "@/shared/components/Card";
import Error from "@/shared/components/form/Error";

// import { isObjEmpty } from "../../shared/helpers";
import {
  ActionIconContainer,
  AddFormButton,
  CustomLoader,
} from "../../../shared/components/TableElements";
import FormField from "../../../shared/components/form/FormField";
import { formInputStyles, formStyles } from "../../../shared/constants/styles";
import { generateTreeArr, isObjEmpty } from "../../../shared/helpers";
import { useSelector } from "react-redux";
import { getGroups, getUsers, postApi } from "../../../api/getUser";
import { updateGroupsList } from "../../../features/groups/groupsSlice";
import { TreeSelect } from "primereact/treeselect";
import { addMsg } from "../../../features/snackbar/snackbarSlice";
import ErrorPopup from "../../../shared/components/ErrorPopup";
import { updateUsersList } from "../../../features/users/usersSlice";

const GroupsFormPopup = ({
  showPopup,
  setShowPopup,
  newGroupInfo,
  setNewGroupInfo,
  mode,
}) => {
  //const history = useHistory();
  const dispatch = useDispatch();
  //const location = useLocation();
  const { t } = useTranslation("common");
  const {
    handleSubmit,
    reset,
    register,
    control,
    watch,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const [saveBtnLoading, setSaveBtnLoading] = useState(false);

  let allGroups = useSelector((state) => state.groups.list);
  let allUsers = useSelector((state) => state.users.list);

  const { userId, roleId } = useSelector((state) => state.user);

  const [groups, setGroups] = useState([]);

  //To toggle error popup while adding/editing form
  const [showErrPopup, setShowErrPopup] = useState(false);

  const generateTreeArrNew = (groups) => {
    const treeData = [];
    const groupMap = new Map();

    groups.forEach((group) => {
      groupMap.set(group.group_id, {
        key: group.group_id,
        group_id: group.group_id,
        label: group.label,
        data: group.group_id,
        level: group.level,
        parent_group: group.parent_group,
        children: [],
      });
    });

    groups.forEach((group) => {
      if (
        !group.parent_group ||
        (!groupMap.has(group.parent_group) &&
          newGroupInfo?.group_id !== group.parent_group)
      ) {
        treeData.push(groupMap.get(group.group_id));
      } else if (groupMap.has(group.parent_group)) {
        groupMap
          .get(group.parent_group)
          .children.push(groupMap.get(group.group_id));
      }
    });

    return treeData;
  };

  useEffect(() => {
    if (allGroups?.length && allUsers?.length && roleId && userId) {
      let groupOptions = [
        {
          label: t("parent_group"),
          value: "parent_group",
          level: 1,
          group_id: "parent_group",
          key: "parent_group",
          // data: {
          //   label: t("parent_group"),
          //   value: "parent_group",
          //   level: 1,
          //   group_id: "parent_group",
          // },
          parent_group: null,
        },
        ...allGroups.filter((g) => g.group_id),
      ];

      //For managers, show them only the groups that are assigned to them
      if (roleId === 2) {
        const currentUser = allUsers.find((u) => u.user_id === userId);
        const assignedGroupIds = currentUser?.group_ids;
        //It is expected that assignedGroupIds will always have atleast one group_id
        //since there will be checks to restrict a manager with group_ids null from adding/editing a group
        if (assignedGroupIds) {
          const assignedGroupIdsArr = JSON.parse(assignedGroupIds);
          groupOptions = groupOptions.filter(
            (g) => assignedGroupIdsArr.includes(g.group_id)
            //|| assignedGroupIdsArr.some((id) => g?.groupNodes?.includes(id))
            // ||  g.group_id === "parent_group"
          );
          if (mode === "from-edit-group") {
            if (newGroupInfo?.level === 1) {
              //If level 1, show parent group
              groupOptions.unshift({
                label: t("parent_group"),
                value: "parent_group",
                level: 1,
                group_id: "parent_group",
                key: "parent_group",
                // data: {
                //   label: t("parent_group"),
                //   value: "parent_group",
                //   level: 1,
                //   group_id: "parent_group",
                // },
                parent_group: null,
              });
            } else {
              //If not level 1, show parent
              if (
                newGroupInfo.parent_group &&
                !groupOptions.some(
                  (g) => g.group_id === newGroupInfo.parent_group
                )
              ) {
                const parentGroup = allGroups.find(
                  (g) => g.group_id === newGroupInfo.parent_group
                );
                groupOptions.unshift(parentGroup);
              }
            }
          }
        }
      }

      if (
        mode === "from-edit-group" &&
        groupOptions.length > 0 &&
        newGroupInfo
      ) {
        groupOptions = groupOptions.filter(
          (g) => g.group_id !== newGroupInfo.group_id
        );
      }

      setGroups(generateTreeArrNew(groupOptions));
      //setGroups(generateTreeArr(groupOptions));
    }
  }, [allGroups, newGroupInfo, mode, roleId, allUsers, userId]);

  const groupName = watch("groupName");
  const parentGroup = watch("parentGroup");
  const desc = watch("desc");

  useEffect(() => {
    if (mode === "from-add-vehicle") {
      setValue("groupName", newGroupInfo?.name);
      if (roleId == 2) {
        setValue("parentGroup", groups[0]?.group_id);
      } else {
        setValue("parentGroup", "parent_group");
      }
    }

    if (mode === "from-edit-group") {
      setValue("groupName", newGroupInfo.group_name);
      setValue("desc", newGroupInfo.description);
      if (newGroupInfo.parent_group) {
        setValue("parentGroup", newGroupInfo.parent_group);
      } else {
        setValue("parentGroup", "parent_group");
      }
    }

    if (mode === "from-add-sub-group") {
      setValue("parentGroup", newGroupInfo.group_id);
    }

    if (!mode) {
      if (roleId == 2) {
        setValue("parentGroup", groups[0]?.group_id);
      } else {
        setValue("parentGroup", "parent_group");
      }
    }
  }, [newGroupInfo, groups]);

  const handleClose = () => {
    //setNewGroupInfo(null);
    reset({
      groupName: "",
      parentGroup: "",
      desc: "",
    });
    if (!isObjEmpty(errors)) {
      clearErrors();
    }
    setShowPopup(false);
  };

  const addGroup = async () => {
    try {
      if (!groupName || groupName?.trim() === "") {
        setError(
          "groupName",
          {
            type: "required",
            message: t("required_err"),
          },
          { shouldFocus: true }
        );
        return;
      } else {
        clearErrors("groupName");
      }

      const parent = allGroups.find((g) => g.key === parentGroup);

      // //parent reqd
      // if (!parent) {
      //   setError(
      //     "parentGroup",
      //     {
      //       type: "custom",
      //       message: t("parent_group_reqd"),
      //     },
      //     { shouldFocus: true }
      //   );
      //   return;
      // } else {
      //   clearErrors("parentGroup");
      // }

      if (parent?.level && parent?.level > 4) {
        setError(
          "parentGroup",
          {
            type: "custom",
            message: t("create_sub_group_err_msg"),
          },
          { shouldFocus: true }
        );
        return;
      } else {
        clearErrors("parentGroup");
      }

      const parentGroupLevel = parent?.level || 0;
      const editGroupLevel = +newGroupInfo?.level || 1;
      let childGroups = [];
      if (
        mode === "from-edit-group" &&
        newGroupInfo?.groupNodes?.length > 0
        //&& parent
      ) {
        let childGroupLevels = [];
        newGroupInfo?.groupNodes?.forEach((id) => {
          const childGroup = allGroups.find((g) => g.group_id === id);
          if (childGroup) {
            childGroups.push(childGroup);
            childGroupLevels.push(childGroup?.level);
          }
        });
        const maxChildGroupLevel = Math.max(...childGroupLevels);
        if (maxChildGroupLevel > 0) {
          const noOfLevels = +maxChildGroupLevel - editGroupLevel + 1;
          const levelLimit = noOfLevels + +parentGroupLevel;
          //console.log("levelLimit", levelLimit);
          if (levelLimit > 5) {
            setError(
              "parentGroup",
              {
                type: "custom",
                message: t("group_level_err_msg"),
              },
              { shouldFocus: true }
            );
            return;
          }
        }
      }

      //console.log("errors", errors);

      if (!isObjEmpty(errors)) {
        return;
      }

      setSaveBtnLoading(true);

      if (mode === "from-edit-group") {
        let groupsToUpdate = [
          {
            parent_group: parent?.group_id || 0,
            group_name: groupName,
            description: desc || "",
            querystring: "add_group",
            level: parentGroupLevel + 1,
            group_id: newGroupInfo.group_id,
            source: "web",
          },
        ];
        const levelsShifted = parentGroupLevel + 1 - editGroupLevel;
        if (levelsShifted !== 0) {
          childGroups.forEach((g) => {
            groupsToUpdate.push({
              parent_group: g?.parent_group,
              group_name: g.group_name,
              description: g.desc || "",
              querystring: "add_group",
              level: g?.level + levelsShifted,
              group_id: g.group_id,
              source: "web",
            });
          });
        }

        let successRes = 0;
        for (let group of groupsToUpdate) {
          const res = await postApi(group, "commonNew");

          if (!res.success) {
            setSaveBtnLoading(false);
            setShowErrPopup(true);
            return;
          }

          if (res.success) {
            successRes += 1;
          }
          if (successRes === groupsToUpdate.length) {
            const groupsList = await getGroups("get_all_groups_list", t);
            dispatch(updateGroupsList(groupsList));
            const snackbarMsg = t("record_edited_msg", {
              recordName: t("group"),
            });
            dispatch(addMsg(snackbarMsg));
            setSaveBtnLoading(false);
            setShowPopup(false);
            return;
          }
        }
      } else {
        const apiData = {
          parent_group: parent?.group_id || 0,
          group_name: groupName,
          description: desc || "",
          querystring: "add_group",
          level: parent?.level ? parent?.level + 1 : 1,
          group_id: mode === "from-edit-group" ? newGroupInfo.group_id : "",
          source: "web",
        };

        const res = await postApi(apiData, "commonNew");
        if (res.success) {
          const groupId = res?.group_id;
          const groupsList = await getGroups("get_all_groups_list", t);
          const snackbarMsg =
            mode === "from-edit-group"
              ? t("record_edited_msg", { recordName: t("group") })
              : t("record_added_msg", { recordName: t("group") });
          dispatch(updateGroupsList(groupsList));

          //Update users when manager creates a new group (since user.group_ids is getting updated)
          if (roleId == 2) {
            const usersList = await getUsers();
            dispatch(updateUsersList(usersList));
          }

          if (mode === "from-add-vehicle") {
            setNewGroupInfo((prev) => ({ ...prev, id: groupId }));
          } else {
            dispatch(addMsg(snackbarMsg));
          }
          setSaveBtnLoading(false);
          setShowPopup(false);
        } else {
          setSaveBtnLoading(false);
          setShowErrPopup(true);
          return;
        }
      }
    } catch (e) {
      setSaveBtnLoading(false);
      setShowErrPopup(true);
      return;
    }
  };

  return (
    <>
      {showErrPopup && (
        <ErrorPopup showPopup={showErrPopup} setShowPopup={setShowErrPopup} />
      )}
      <Modal
        show={showPopup}
        size="md"
        style={{ zIndex: 999 }}
        //autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header>
          <h4>
            {mode === "from-edit-group" ? t("edit_group") : t("add_group")}
          </h4>
          <div
            className="d-flex justify-content-end"
            //style={{ width: "-webkit-fill-available" }}
          >
            <ActionIconContainer onClick={handleClose}>
              <i className="fi fi-rr-cross-small" />
            </ActionIconContainer>
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            height: `${window.innerHeight - 320}px`,
            overflow: "auto",
            //zIndex: 1000,
          }}
        >
          <FormContainer>
            <Container>
              <Card>
                <CardBody
                // style={{
                //   height: `${window.innerHeight - 400}px`,
                //   overflow: "auto",
                // }}
                >
                  <Row>
                    <Col>
                      <FormGroupLabel className="m-0">
                        {t("group_name")}
                      </FormGroupLabel>
                      <FormItem disabled={false}>
                        <FormField
                          name="groupName"
                          control={control}
                          component="input"
                          defaultValue=""
                          placeholder={t("group_name")}
                          style={formInputStyles}
                          disabled={false}
                          rules={{ required: t("required_err") }}
                        />
                      </FormItem>

                      {errors?.groupName && (
                        <Error error={errors.groupName.message} />
                      )}
                    </Col>

                    <Col>
                      <FormGroupLabel className="m-0">
                        {t("parent_group")}
                      </FormGroupLabel>
                      <Controller
                        name="parentGroup"
                        control={control}
                        //errors={errors}
                        render={({ field: { onChange, value, ref } }) => (
                          // <Select
                          //   options={groupOptions}
                          //   //value={vehicles.find((c) => c.value === value)}
                          //   value={value}
                          //   onChange={onChange}
                          //   //onCreateOption={handleCreate}
                          //   placeholder={t("parent_group")}
                          //   styles={formStyles}
                          //   isDisabled={false}
                          // />
                          <>
                            <TreeSelect
                              id="group-treeselect-dropdown"
                              value={value}
                              onChange={(g) => {
                                onChange(g);
                                clearErrors("parentGroup");
                              }}
                              options={groups}
                              //className="md:w-20rem w-full"
                              placeholder={t("select_item")}
                              filter={true}
                              //filterInputAutoFocus={true}
                              className="form-treeselect"
                              inputRef={ref}
                            ></TreeSelect>
                          </>
                        )}
                        rules={{ required: t("required_err") }}
                      />

                      {errors?.parentGroup && (
                        <Error error={errors.parentGroup.message} />
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <FormGroupLabel>{t("desc")}</FormGroupLabel>
                      <FormItem disabled={false}>
                        <FormField
                          name="desc"
                          control={control}
                          component="input"
                          defaultValue=""
                          placeholder={t("desc")}
                          style={formInputStyles}
                          disabled={false}
                        />
                      </FormItem>

                      {errors?.desc && <Error error={errors.desc.message} />}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </FormContainer>
        </Modal.Body>
        <Modal.Footer>
          <AddFormButton id="save-form-button" type="button" onClick={addGroup}>
            {saveBtnLoading ? <CustomLoader /> : t("save")}
          </AddFormButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GroupsFormPopup;
